/* eslint-disable react/no-array-index-key */
/* eslint-disable no-console */
import React, { Fragment } from 'react';
import './index.css';
import { withTranslation } from 'react-i18next';
import ItemTransporte from './item-transporte';
import CityName from '../../../../commons/iataRenderService';

const Transporte = (props) => {
  const { transporte, origen = '', destino = '', t } = props;

  const listarSegmentos = () => {
    try {
      return [
        ...transporte.transporteAereo.itinerarioVuelo.informeIda.segmentos.concat(
          transporte.transporteAereo.itinerarioVuelo.informeVuelta.segmentos,
        ),
      ];
    } catch (e) {
      console.error(`Error parseando transporte: ${e}`);
      return [];
    }
  };

  return (
    <Fragment>
      <div className="simplification">
        <CityName code={origen} /> ({origen}
        ) -
        <CityName code={destino} /> ({destino})
        {transporte.transporteAereo.nombreLineaAerea !== null ? (
          <span>
            {`${t('layout:packages.details.traveling_with')}: `}
            <b>{transporte.transporteAereo.nombreLineaAerea}</b>
          </span>
        ) : null}
      </div>
      {listarSegmentos().map((segmento, index) => (
        <ItemTransporte
          key={index}
          segmento={segmento}
          aerolinea={transporte.transporteAereo.nombreLineaAerea}
          img={transporte.imagen}
        />
      ))}
    </Fragment>
  );
};

export default withTranslation()(Transporte);
